import React from 'react';

import QuotaWinterSedes  from 'components/Tvendo/Sale/QuotaBPartner/WinterCuotas/QuotaSedes/List.js';

export default function () {
  return <QuotaWinterSedes  />;
}
